import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';

function Section({ section, terms, selectedSections, onChange }) {
    const findTerm = R.compose(
        R.head,
        R.filter(t => R.contains(section.id, t.section_ids))
    );

    const term = findTerm(terms);
    const key = 'section-' + section.id;

    const checkedStatus = {
        checked: selectedSections.includes(section.id),
        onChange({ currentTarget: { checked } }) {
            let newValue;
            if (checked) {
                newValue = [...selectedSections, section.id];
            } else {
                newValue = selectedSections.filter(i => i !== section.id);
            }
            onChange(newValue);
        },
    };

    return (
        <li key={key}>
            <input
                type="checkbox"
                id={key}
                checked={checkedStatus.checked}
                onChange={checkedStatus.onChange}
            />
            <label htmlFor={key}>
                {section.course_title} #{section.class_number} ({term.name})
            </label>
        </li>
    );
}
Section.propTypes = {
    section: PropTypes.shape({
        id: PropTypes.number,
        class_number: PropTypes.any, // I doubt this is actually a number
        course_title: PropTypes.string,
    }).isRequired,
    terms: PropTypes.array,
    selectedSections: PropTypes.array,
    onChange: PropTypes.func,
};

const defaultLegend = (
    <legend>
        <span className="aural">Required: Check at least one </span>Sections
    </legend>
);

export default function DestinationSections({
    error,
    legend = defaultLegend,
    onChange,
    sections,
    selectedSections,
    terms,
}) {
    const selectAll = {
        checked: selectedSections.length === sections.length,
        onChange({ currentTarget: { checked } }) {
            let newValue = [];
            if (checked) {
                newValue = sections.map(s => s.id);
            }

            onChange(newValue);
        },
    };

    // in case of an error, we'll need to map the first element with a
    // aria-describeby attribute which value coordinates with an id
    // of the error message. if no error is found, then the attribute
    // will not be present.
    const describedById = error ? 'error-sections' : null;

    return (
        <fieldset>
            {legend}
            <div className="well">
                <ul>
                    <li>
                        <input
                            type="checkbox"
                            id="all-sections"
                            checked={selectAll.checked}
                            onChange={selectAll.onChange}
                            aria-describedby={describedById}
                        />
                        <label htmlFor="all-sections">All Courses</label>
                    </li>
                    {sections.map((s, index) => {
                        return (
                            <Section
                                key={`s-${s.id}`}
                                selectedSections={selectedSections}
                                onChange={onChange}
                                terms={terms}
                                section={s}
                            />
                        );
                    })}
                </ul>
            </div>
        </fieldset>
    );
}
DestinationSections.propTypes = {
    sections: PropTypes.array,
    terms: PropTypes.array,
    legend: PropTypes.node,
    error: PropTypes.string,
    selectedSections: PropTypes.array,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/destination_sections.jsx